import React, { useState, useEffect, useRef } from "react";

const HeaderMenu = ({ link_list }) => {
    const [hoveredLink, setHoveredLink] = useState(null);
    const menuLinks = link_list[0].links;
    const navigationRef = useRef(null);
    const leaveTimeoutRef = useRef(null);

    useEffect(() => {
        const handleMenuClose = () => {
            setHoveredLink(null);
        };

        const handleMegamenuEnter = () => {
            // Cancel any pending close timeout when user enters megamenu area
            if (leaveTimeoutRef.current) {
                clearTimeout(leaveTimeoutRef.current);
                leaveTimeoutRef.current = null;
            }
        };

        // Listen for megamenu-closed events
        window.addEventListener("megamenu-closed", handleMenuClose);
        window.addEventListener("megamenu-enter", handleMegamenuEnter);

        // Dispatch megamenu-hover event when hoveredLink changes
        if (hoveredLink !== null) {
            const event = new CustomEvent('megamenu-hover', {
                detail: { message: `header-${hoveredLink}` }
            });
            window.dispatchEvent(event);
        }

        return () => {
            window.removeEventListener("megamenu-closed", handleMenuClose);
            window.removeEventListener("megamenu-enter", handleMegamenuEnter);
            if (leaveTimeoutRef.current) {
                clearTimeout(leaveTimeoutRef.current);
            }
        };
    }, [hoveredLink]);

    const handleNavLeave = () => {
        // Add a delay to allow user to move to submenu without triggering close
        leaveTimeoutRef.current = setTimeout(() => {
            setHoveredLink(null);
            // Dispatch the megamenu-closed event to coordinate with other components
            const event = new CustomEvent('megamenu-closed');
            window.dispatchEvent(event);
            
            // Also use the navigation store if available
            if ((window as any).Alpine?.store) {
                (window as any).Alpine.store('navigation').setMenuId(null);
            }
        }, 200);
    };

    const handleNavEnter = () => {
        // Clear any pending close timeout when re-entering the navigation area
        if (leaveTimeoutRef.current) {
            clearTimeout(leaveTimeoutRef.current);
            leaveTimeoutRef.current = null;
        }
    };

    const handleLinkEnter = (dataId) => {
        // Clear any pending close timeout
        if (leaveTimeoutRef.current) {
            clearTimeout(leaveTimeoutRef.current);
            leaveTimeoutRef.current = null;
        }
        setHoveredLink(dataId);
    };

    return (
        <div 
            className="header-links" 
            ref={navigationRef}
            onMouseLeave={handleNavLeave}
            onMouseEnter={handleNavEnter}
        >
            <div className="block">
                <ul className="inline-flex header-menu">
                    {menuLinks.map((link, id) => {
                        const titleLowerCase = link.title.toLowerCase();
                        const dataId = titleLowerCase.replace(' ', '-');
                        const activeClass = link.active ? 'active' : 'inactive';
                        const hoverClass = hoveredLink === dataId ? 'hovered' : '';

                        return (
                            <li className="b2" data-id={`header-${dataId}`} key={id}>
                                <a
                                    href={link.url}
                                    className={`${activeClass} ${hoverClass} menu-link`}
                                    onMouseEnter={() => handleLinkEnter(dataId)}
                                >
                                    {link.title}
                                </a>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};

export default HeaderMenu;